import React, { useState } from "react";
import ChangeStylistModal from "./ChangeStylistModal";
import axios from "axios";
import AssignStylist from "./AssignStylist";
import { getProvidersByZipcodeAndService } from "services/provider.service";

const ChangeStylist = ({
  activeOrder,
  selectedRow,
  getallOrders,
  getOrderById,
  toggleModel,
  isHotel,
  providerId,
  pastPendingTab,
}) => {
  const [modal, setModal] = useState(false);
  const [newProviders, setNewProviders] = useState([]);
  const [newProviderOptions, setNewProviderOptions] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const toggle = () => {
    setModal(!modal);
  };

  const getProvidersByZipCode = async activeOrder => {
    if (selectedRow) {
      // setServiceIdSelected(serviceIdSelected);
      getProviders(activeOrder?.zipcode, selectedRow?.serviceid?._id);
    } else {
      getProviders(activeOrder?.zipcode, []);
    }
    setOpenModal(true);
    // }
  };

  const getProviders = (zipcode, serviceId) => {
    setLoading(true);
    let body = {
      serviceid: serviceId,
      zipcode: zipcode,
    };
    getProvidersByZipcodeAndService(body).then(async res => {
      let options = res?.data?.map(provider => ({
        label: provider?.publicProfile?.publicName
          ? provider?.publicProfile?.publicName
          : provider?.legalname + " " + provider?.shortname,
        value: provider?._id,
        profileimage: provider?.image,
        companyId: provider?.compaines ? provider?.compaines[0] : "",
        exp: provider?.experience ? provider?.experience : "",
      }));
      setLoading(false);
      setNewProviders(res?.data);
      setNewProviderOptions(options);
    });
  };
  return (
    <>
      <div>
        {isHotel === true && pastPendingTab === true ? (
          " "
        ) : providerId ? (
          <button
            className="btn btn-sm px-3 py-1 font-size-12 btn-primary-red"
            onClick={() => {
              toggle();
              getProvidersByZipCode(activeOrder);
            }}
          >
            Change Stylist
          </button>
        ) : (
          <button
            className="btn btn-sm px-3 py-1 font-size-12 btn-primary-red"
            onClick={() => {
              toggle();
              getProvidersByZipCode(activeOrder);
            }}
          >
            Assign Stylist
          </button>
        )}
      </div>

      {isHotel === true ? (
        <AssignStylist
          toggle={toggle}
          modal={modal}
          AvailableProviders={newProviderOptions}
          providers={newProviders}
          selecteditem={selectedRow}
          activeOrder={activeOrder}
          loading={loading}
          getallOrders={getallOrders}
          getOrderById={getOrderById}
          toggleModel={toggleModel}
        />
      ) : (
        <ChangeStylistModal
          toggle={toggle}
          modal={modal}
          AvailableProviders={newProviderOptions}
          providers={newProviders}
          selecteditem={selectedRow}
          activeOrder={activeOrder}
          loading={loading}
          getallOrders={getallOrders}
          getOrderById={getOrderById}
          toggleModel={toggleModel}
        />
      )}
    </>
  );
};

export default ChangeStylist;
